/*
 * kc-reveal.js - fade-up on scroll for any element with [data-kc-reveal] (own code, no libraries).
 * CSS lives in the section that uses it (see sections/kc-contact.liquid). Respects prefers-reduced-motion.
 */
(() => {
  if (window.__kcReveal) return;
  window.__kcReveal = true;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const show = (el) => el.classList.add('is-visible');

  const io = !reduced && 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' })
    : null;

  const scan = (root = document) => {
    root.querySelectorAll('[data-kc-reveal]:not(.is-visible)').forEach((el) => (io ? io.observe(el) : show(el)));
  };

  scan();
  // theme editor: sections are re-rendered on the fly
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
})();
